export default __webpack_public_path__ + "static/media/wichita4.e033fc90.jpeg";